/** Normalize axios / API errors for identity forms — never show raw `{}`. */
export function formatIdentityError(err, fallback = "Something went wrong. Please try again.") {
  const data = err?.response?.data;
  const candidates = [
    data?.error,
    data?.detail,
    data?.message,
    data?.dharma_error?.detail,
    err?.message,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim() && value.trim() !== "{}") {
      return value.trim();
    }
  }
  return fallback;
}
